import React from 'react';
import {Header} from '../components/g2/header/Header';
import {LinkPiles} from '../components/common/linkpiles/LinkPiles';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import {AsyncSiteHeader} from '../components/common/site-header/AsyncSiteHeader';
import {AsyncSiteFooter} from '../components/common/site-footer/AsyncSiteFooter';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import {TESTS} from '../utils/abacus';

export const Template = () => (
    <React.Fragment>
        {withErrorBoundary(
            <MvtTest test={TESTS.WHITE_HEADER} report reportOnMount>
                <AsyncSiteHeader />
            </MvtTest>
        )}
        <Header />
        <main className="app-main">
            <LinkPiles />
        </main>
        <MmgLinks />
        {withErrorBoundary(<AsyncSiteFooter />)}
    </React.Fragment>
);
